import React, {useState} from 'react';
import './modalComponent.css';

function ModalComponent({modalActive, setModalActive,setErrorBox, title, children}) {

  const closeModalActive =()=>{
    setModalActive(false);
    setErrorBox('');
  }

  return (
    <div className={modalActive ? 'modal-component active' : 'modal-component'}>
      <div className="wrapper" onClick={closeModalActive}></div>
      <div className='box'>
        <div className="box-title">
          <span>{title}</span>
        </div>
        <div className="box-cancel" onClick={closeModalActive}>
          <i className='bx bx-x'></i>
        </div>
         {children}
      </div>
    </div>
  )
}

export default ModalComponent
